import { defineComponent as _defineComponent } from 'vue'
import { BigDecimal } from "@/models/store/big.decimal";
import {computed, PropType} from "vue";
import FormattedNumber from "./FormattedNumber.vue";

// const props = defineProps<{
//   amount: bigint | number | BigDecimal ,
//   precision: number
// }>();


export default /*#__PURE__*/_defineComponent({
  __name: 'PercentsView',
  props: {
  amount: [Object, Number, BigDecimal] as PropType<bigint | number | BigDecimal>,
  precision: Number,
  removeDec: {
    type : Boolean,
    required: false,
    default: true
  },
},
  setup(__props, { expose: __expose }) {
  __expose();


const props =  __props;

const amount = computed(() => {
  if (typeof props.amount === 'number') {
    if (isNaN(props.amount)) {
      return Number.NaN;
    }
    return props.amount * 100;
  } else if (typeof props.amount === 'bigint') {
    return props.amount * 100n;
  } else if (props.amount){
    return props.amount.multiply(100);
  } else {
    return 0;
  }
});

const __returned__ = { props, amount, FormattedNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})